import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { AgencyModel } from '@models/agency'

const generateTabBarItems = (agency: AgencyModel, urls: { editAgencyUrl: string }) => {
  const { editAgencyUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editAgencyUrl,
      key: 'details',
      title: agency?.title || 'Agency Details',
    },
  ]
}

export default generateTabBarItems
